import React, { Component } from "react";
import { toast } from "react-toastify";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import { Badge } from "react-bootstrap";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import { getPendingRenewals } from "../services/dashboardService";
import PageLoading from "./common/pageLoading";

class PendingRenewals extends Component {
  state = {
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  async componentDidMount() {
    await this.getPendingRenewals();
  }

  async getPendingRenewals() {
    try {
        let renewals = [];
        const { data } = await getPendingRenewals();
        renewals = data;
        this.setState({ renewals });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

//   handleSearch = async (e) => {
//     this.setState({ loading: true });
//     const { currentPage, pageSize } = this.state;
//     const value = e.currentTarget.value;
//     this.setState({ searchQuery: value, currentPage: 1 });
//     await this.populateTransactions(currentPage, pageSize, value);
//   };

  render() {
    const {
        renewals,
        loading,
    } = this.state;

    return (
      <React.Fragment>
        <div className="card">
            <div className="card-header main-color-bg">
                <h5>Pending Renewals</h5>
            </div>
            <div className="card-body">
                <span className="card-text">
                    {loading && <PageLoading loading={loading} />}
                    {loading === false && (
                    <TableContainer component={Paper} className="mt-4">
                        <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                            <StyledTableCell>Customer</StyledTableCell>
                            <StyledTableCell align="right">Equipment</StyledTableCell>
                            <StyledTableCell align="right">Start Date</StyledTableCell>
                            <StyledTableCell align="right">End Date</StyledTableCell>
                            <StyledTableCell align="right">Type</StyledTableCell>
                            <StyledTableCell align="right">Status</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {renewals &&
                            renewals.map((renewal) => (
                                <StyledTableRow key={renewal._id}>
                                <StyledTableCell component="th" scope="row">
                                    {renewal.user}
                                </StyledTableCell>
                                <StyledTableCell align="right">{renewal.equipment}</StyledTableCell>
                                <StyledTableCell align="right">{renewal.formattedStartDate}</StyledTableCell>
                                <StyledTableCell align="right">{renewal.formattedEndDate}</StyledTableCell>
                                <StyledTableCell align="right">{renewal.type}</StyledTableCell>
                                <StyledTableCell align="right">
                                    <Badge variant={`${renewal.status === "Active" ? "success" : "danger"}`}>{renewal.status}</Badge>
                                </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        </Table>
                    </TableContainer>          
                    )}
                </span>
            </div>
        </div>
      </React.Fragment>
    );
  }
}

export default PendingRenewals;
